import { utility_controller } from '../utility/utility_controller'
import { initAnchorMenuHighlighting } from '../anchorbehaviour/anchor_menu_highlight'

var activateCurrentMenuPoint = function () {
	// WooCommerce documents keep WordPress' server-rendered menu state. In the
	// opt-in hybrid mode, normal Lay pages do use AJAX and must clear their old
	// state before activating the destination item.
	var isHybridAjaxPage = layData.navigation_policy && layData.navigation_policy.enabled && !layData.navigation_policy.currentBlocked
	if (!layData.woocommerce_active || isHybridAjaxPage) {
		jQuery('.current-menu-parent').removeClass('current-menu-parent')
		jQuery('.current-menu-ancestor').removeClass('current-menu-ancestor')
		jQuery('.current-menu-item:not(.qtranxs-lang-menu-item)').removeClass('current-menu-item')
		// since woocommerce support, i needed to style "current_page_item" as an active menu point as well, because
		// pages like "Shop" dont use "current-menu-item". However, non-woocommerce pages use "current_page_item" too
		// so I need to remove that class on page-switch, otherwise sometimes we'd have "current-menu-item" AND "current_page_item" = 2 menu points marked as active by CSS
		jQuery('.current_page_item:not(.qtranxs-lang-menu-item)').removeClass('current_page_item')
	}

	var $anchor = []
	// if (window.history.state != null && window.history.state.id && window.history.state.type) {
	// 	$anchor = jQuery('nav a[data-id="' + window.history.state.id + '"][data-type="' + window.history.state.type + '"]')
	// } else {
	var id = jQuery('body').attr('data-id')
	var type = jQuery('body').attr('data-type')
	$anchor = jQuery('nav a[data-id="' + id + '"][data-type="' + type + '"]')
	// }

	if ($anchor.length != 0) {
		$anchor.each(function () {
			jQuery(this.parentNode).addClass('current-menu-item')
			jQuery(this.parentNode.parentNode).closest('li.menu-item').addClass('current-menu-parent')
		})
	}

	// Category highlights (parent + submenu) only apply when we're on a project.
	// When on a page, body may still have data-catid from the previous project; don't re-apply those.
	var catids = []
	if (type === 'project') {
		catids = utility_controller.parseIdsString(jQuery('body').attr('data-catid'))
		if (!Array.isArray(catids)) {
			catids = [catids]
		}
		// add class to post parent (category anchor of current project)
		for (var i = 0; i < catids.length; i++) {
			var catid = catids[i]
			var $anchor = jQuery('nav a[data-catid="' + catid + '"][data-type="category"]')
			if ($anchor.length != 0) {
				$anchor.each(function () {
					jQuery(this.parentNode).addClass('current-menu-item')
					jQuery(this.parentNode.parentNode).closest('li.menu-item').addClass('current-menu-parent')
				})
			}
		}
	}

	if (type == 'project') {
		jQuery('.lay-projects-overview').addClass('current-menu-item')
	}

	window.laytheme.emit('current-menu-point-activated')

	initAnchorMenuHighlighting()
}

export { activateCurrentMenuPoint }
